module.exports = __webpack_public_path__ + "img/柚子4.f1844155.png";